import {
  BrowserRouter,
  Route,
  Routes,
  useNavigate,
} from "react-router";
import Layout from './layout/layout';
import { lazy, useEffect } from "react";

import { Suspense } from "react";
import Loaders from "./components/loader/loader";
import socketService from "./service/socket";
import { useDispatcher } from "./custom_hooks/use_app_dispatch";
// import CampaingManagement from "./modules/campaign-management";
import Login from "./components/login/login";
import PrivateRoute from "./../src/PrivateRoute";
// import Dashboard from "./modules/dashboard";
// import NavigationHandler from "./components/custom_components/navigationHandler";

// // Contacts
// const Contacts = lazy(() => import("./modules/contacts/contacts"));
// const Contactdetails = lazy(() => import("./modules/contacts/contactdetails"));
// const Connectors = lazy(() => import("./modules/contacts/connectors"));
// const Apiconfiguration = lazy(() => import("./modules/contacts/apiconfiguration"));

// // Analytics
// const Analytics = lazy(() => import("./modules/analytics/analytics"));
// const AiAnalytics = lazy(() => import("./modules/analytics/ai_analytics/aiAnalytics"));
// const RevenueAnalytics = lazy(() => import("./modules/analytics/revenue_analytics/revenueAnalytics"));
// const CampaignAnalytics = lazy(() => import("./modules/analytics/campaign_analytics/campaignAnalytics"));
// const NpsAnalytics = lazy(() => import("./modules/analytics/nps_analytics/npsAnalytics"));

// // campaign
// const Campaign = lazy(() => import('./modules/campaign/campaign'));

// // Settings
// const Settings = lazy(() => import("./modules/settings"));
// const Smschannel = lazy(() => import("./modules/settings/sms/smschannel"));
// const Viewnumbsms = lazy(() => import("./modules/settings/sms/viewnumbsms"));
// const Whtsappchnl = lazy(() => import("./modules/settings/whtsapp/scss/whtsappchnl"));
// const Whtsappchnlview = lazy(() => import("./modules/settings/whtsapp/scss/whtsappchnl"));
// const Whtsappchnledit = lazy(() => import("./modules/settings/whtsapp/whtsappedit"));
// const Whtsappeditpage = lazy(() => import("./modules/settings/whtsapp/whtsappeditpage"));
// const Email = lazy(() => import("./modules/settings/email/email"));

// // Engagement Reports
// const CampaignReports = lazy(() => import("./modules/campaign_reports/campaignReports"));
// const CampaignReportsIndividual = lazy(() => import("./modules/campaign_reports/campaignReports_view/campaignReportsIndividual"));

// // Customer Value Segment
// const CustomerValueSegment = lazy(() => import("./modules/customer_value_segment/customerValueSegment"));

// // customsatification
// const Csat = lazy(()=>import('./modules/settings/customersatisfaction/index'))
// const FeedbackForm = lazy(()=>import('./modules/settings/customersatisfaction/createfeedbackform/createFeedbackForm'));


// const BuyerPerson = lazy(()=>import('./modules/newscreens/buyer_person/buyerPerson'));
// const BuyerPersonMenu = lazy(()=>import('./modules/newscreens/buyer_person/buyerPersonMenu'));

// Demo Modules
import AiPilot from "./modules/aiPilot";
import Settings from "./modules/settings";
import AddDomain from "./modules/settings/apiconfiguration/addDomain";
import AddEmailAddress from "./modules/settings/channelConfiguration/email/addEmailAddress";
import SetupSmtpEmail from "./modules/settings/channelConfiguration/email/setupSmtpEmail";
import SupportAddress from "./modules/settings/channelConfiguration/email/supportAddress";
import AddWorktualAddress from "./modules/settings/channelConfiguration/email/addWorktualAddress";
import CreateTemplates from "./modules/settings/templates/createTemplates";
import Customer_Profile from "./modules/customer_profile";
import CardCampaigns from "./modules/campaigns/cardcampaigns";
import Campaigns from "./modules/campaigns";
import CreateCampaign from "./modules/campaigns/createCampaign";
import Sms from "./modules/campaigns/sms";
import EmailCampaign from "./modules/campaigns/emailCampaign";
import InApp from "./modules/campaigns/inApp";
import AppPush from "./modules/campaigns/appPush";
import ModifyWhatsapp from "./modules/campaigns/modifyWhatsapp";
import AiPilotAnimation from "./modules/aiPilotAnimate/index";
// campaign new flow
import Createcampaignemail from "./newpages/createcampaign/createcampaignemail"
import Varianttype from "./newpages/createcampaign/varianttype";
import Elevatebrand from "./newpages/orchestration/chat";
import AiChat from "./newpages/aiChat/aiChat";
import { GetItemFromStorage } from "./custom_hooks/useStorage";
import { LocalStorage } from "./custom_hooks/localStorageKeys";
import Reports from "./modules/reports";
import Orchestrate1 from "./modules/aiPilotAnimate/orchestrate1";
import OrchestrationTs from "./modules/aiPilotAnimate/orchestrationts";
import Orchestrate2 from "./modules/aiPilotAnimate/orchestrate2";
import Orchestrate4 from "./modules/aiPilotAnimate/orchestrate4";
import EmailConfig from "./modules/settings/campaignChannelConfig/EmailConfig";
import SmsConfig from "./modules/settings/campaignChannelConfig/SmsConfig";
import AppPushConfig from "./modules/settings/campaignChannelConfig/AppPushConfig";
import WhatsAppConfig from "./modules/settings/campaignChannelConfig/WhatsappConfig";
import WebPushConfig from "./modules/settings/campaignChannelConfig/WebpushConfig";


function App() {
  const dispatch = useDispatcher()
  const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
  const navigate = useNavigate();

  const removeLoader = () => {
    const loader = document.getElementById('contact_center_mainloader');
    if (loader) {
      loader.style.display = 'none';
    }
  };
  
  useEffect(()=>{
    if(accessToken){
      socketService.init(accessToken, navigate, dispatch);
    }
  },[accessToken])
  useEffect(() => {
    removeLoader();
  }, []);
   useEffect(()=>{
    window.addEventListener("message", (event) => {
      console.log("message",event.data.type)
      if (event.origin !== "http://localhost:4000") return;

      // const { type, token } = event.data;
      // if (type === "SET_TOKEN" && token) {
      //   SetItemInStorage(LocalStorage.ACCESS_TOKEN,token)
      //   console.log("Token received and stored:", token);
      // }
    });
  },[])

  return (
    <>
      {/* <NavigationHandler/> */}
      <Suspense fallback={null}>
        <Routes> 
          <Route path="/" element={<Suspense fallback={<Loaders />}><Login /></Suspense>} />
          <Route path="/login" element={<Suspense fallback={<Loaders />}><Login /></Suspense>} />
         {/* Protected Route */}
         <Route element={<PrivateRoute />}>
          <Route element={<Layout />}>
            <Route path="/aiPilot" element={<AiPilot />} />
            <Route path="/aiPilotAnimation" element={<AiPilotAnimation />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="settings/add_domain" element={<AddDomain />} />
            <Route path="/settings/add_emailaddress" element={<AddEmailAddress />} />
            <Route path="/settings/setup_smtp" element={<SetupSmtpEmail />} />
            <Route path="/settings/support_address" element={<SupportAddress />} />
            <Route path="/settings/worktual_address" element={<AddWorktualAddress />} />
            <Route path="/customer_profile" element={<Customer_Profile />} />
            <Route path="/aiPilot" element={<AiPilot />} />
            <Route path="/cardcampaigns" element={<CardCampaigns />} />
            <Route path="/settings/create_templates" element={<CreateTemplates />} />

            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/email" element={<EmailConfig />} />
            <Route path="/sms" element={<SmsConfig />} />
            <Route path="/webpush" element={<WebPushConfig />} />
            <Route path="/apppush" element={<AppPushConfig />} />
            <Route path="/whatsapp" element={<WhatsAppConfig />} />
            
            <Route path="/createCampaign" element={<CreateCampaign />} />
            <Route path="/campaign/campaign_name/sms" element={<Sms />} />
            <Route path="/campaign/campaign_name/email" element={<EmailCampaign />} />
            <Route path="/campaign/campaign_name/in_app" element={<InApp />} />
            <Route path="/modifyWhatsapp" element={<ModifyWhatsapp />} />
            <Route path="/campaign/campaign_name/app_push" element={<AppPush />} />
             {/* <Route path="/campaignemail" element={<Createcampaignemail/>} /> */}
            <Route path="/campaignemail" element={<Varianttype/>} />
            <Route path="/elevate" element={<Elevatebrand/>} />
            <Route path="/aichat" element={<AiChat/>} />
            <Route path="/chatblock" element={<OrchestrationTs/>} />
          </Route>
        </Route>
        <Route path="*" element={<Suspense fallback={<Loaders />}><Login /></Suspense>} />
        </Routes>
      </Suspense>
    </>
  )
}

export default App
